export default class HoldingTransaction {
	constructor() {
		this.TransactionDate = null;
		this.TransactionType = null;
		this.NumberOfShares = null;
		this.PricePerShare = null;
		this.Brokerage = null;
	}
}
